import AgentResultListView from 'views/agents/agentResultListView'
import ResearchResultListItemView from 'views/research/researchResultListItemView'

var ResearchResultListView = AgentResultListView.extend({
  itemView: ResearchResultListItemView
});

export default ResearchResultListView;

